import { render, staticRenderFns } from "./cardTopButton-editor.vue?vue&type=template&id=952fd2da&scoped=true&"
import script from "./cardTopButton-editor.vue?vue&type=script&lang=js&"
export * from "./cardTopButton-editor.vue?vue&type=script&lang=js&"
import style0 from "./cardTopButton-editor.vue?vue&type=style&index=0&id=952fd2da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952fd2da",
  null
  
)

export default component.exports